module.exports = __webpack_public_path__ + "static/img/311.9e408ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/210427/311.jpg
// module id = J08S
// module chunks = 0